// Import model
import { FilterOtgLaminatesCatalogStyleRequest } from '../models/FilterOtgLaminatesCatalogStyleRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { OtgLaminatesCatalogStyleCondition } from '../models/OtgLaminatesCatalogStyleCondition';
import { OtgLaminatesCatalogStyleFields } from '../models/OtgLaminatesCatalogStyleFields';
import { OtgLaminatesCatalogStyleIndexedFields } from '../models/OtgLaminatesCatalogStyleIndexedFields';

// Import dependency serializers (for complex types)
import { OtgLaminatesCatalogStyleConditionSerializer } from './OtgLaminatesCatalogStyleConditionSerializer';
import { OtgLaminatesCatalogStyleFieldsSerializer } from './OtgLaminatesCatalogStyleFieldsSerializer';
import { OtgLaminatesCatalogStyleIndexedFieldsSerializer } from './OtgLaminatesCatalogStyleIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterOtgLaminatesCatalogStyleRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterOtgLaminatesCatalogStyleRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterOtgLaminatesCatalogStyleRequest instance
   */
  static deserialize(json: string): FilterOtgLaminatesCatalogStyleRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterOtgLaminatesCatalogStyleRequest instance
   */
  static fromObject(obj: any): FilterOtgLaminatesCatalogStyleRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterOtgLaminatesCatalogStyleRequest');
    }


    const instance: FilterOtgLaminatesCatalogStyleRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as OtgLaminatesCatalogStyleIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as OtgLaminatesCatalogStyleFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        OtgLaminatesCatalogStyleConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterOtgLaminatesCatalogStyleRequest instances
   */
  static deserializeArray(json: string): FilterOtgLaminatesCatalogStyleRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterOtgLaminatesCatalogStyleRequest instance to a JSON string
   */
  static serialize(instance: FilterOtgLaminatesCatalogStyleRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterOtgLaminatesCatalogStyleRequest instance to a plain object
   */
  static toObject(instance: FilterOtgLaminatesCatalogStyleRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        OtgLaminatesCatalogStyleConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterOtgLaminatesCatalogStyleRequest instances to a JSON string
   */
  static serializeArray(instances: FilterOtgLaminatesCatalogStyleRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
